import type { FunctionPlugin } from 'vue';

const DocumentationPlugin: FunctionPlugin = function () {
  // Nothing to do here
};

export default DocumentationPlugin;
